


import group2Api from '@/apis/group2';
import group3Api from '@/apis/group3';
import { AdminListTableField } from '@/types/adminListTable';
import { AdminGroup2 } from '@/models/apis/group2/adminGroup2Response';
import { AdminGroup3 } from '@/models/apis/group3/adminGroup3Response';
import { defineComponent, computed, onMounted, reactive } from '@vue/composition-api';

interface Group3Disp extends AdminGroup3 {
  g2Name: string;
}

interface SearchParam {
  parent_id: number | null;
}

interface AdminGroup3State {
  groups3Orig: AdminGroup3[];
  filteredGroups3: AdminGroup3[];
  groups2: AdminGroup2[];
  search: SearchParam;
}

export default defineComponent({
  name: 'admin-groups3',
  setup() {
    const initSearchState = (): SearchParam => ({
      parent_id: null,
    });

    const state = reactive<AdminGroup3State>({
      groups3Orig: [],
      filteredGroups3: [],
      groups2: [],
      search: initSearchState(),
    });

    const displayData = computed<Group3Disp[]>(() => {
      const group2NameMap = state.groups2.reduce<Record<number, string>>((acc, group2) => {
        if (group2.id !== null) {
          acc[group2.id] = group2.name;
        }
        return acc;
      }, {});
      return state.filteredGroups3.map(group3 => ({
        ...group3,
        g2Name: group3.parent_id !== null ? (group2NameMap[group3.parent_id] || '-') : '-',
      }));
    });

    const fields: AdminListTableField[] = [
      { name: 'g2Name', label: '事業所名' },
      { name: 'name', label: '部署名' },
      { name: 'disp_order', label: '表示順' },
    ];

    const canEditRow = () => false;
    const canDeleteRow = () => false;

    const filterSearch = () => {
      state.filteredGroups3 = state.groups3Orig.filter(group3 => {
        if (state.search.parent_id == null || state.search.parent_id.toString() === '') {
          return true;
        }
        return group3.parent_id === state.search.parent_id;
      });
    };

    const resetSearchResults = () => {
      state.filteredGroups3 = [];
    };

    const doSearch = async() => {
      resetSearchResults();
      const { data } = await group3Api.adminIndex();
      state.groups3Orig = data || [];
      filterSearch();
    };

    onMounted(async() => {
      const { data } = await group2Api.adminIndex();
      state.groups2 = data || [];
      await doSearch();
    });

    return {
      state,
      displayData,
      fields,
      canEditRow,
      canDeleteRow,
      doSearch,
    };
  },
});
